import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CmsPageAction } from "../../../redux/Action/CmsPageAction";
import { useLocation } from "react-router-dom";
import { StorageConstants } from "../../../constants/Constants";
import Spinner from "../../../components/Spinner";

const PrivacyAndPolicy = () => {
    const dispatch = useDispatch<any>();
    const { pathname } = useLocation();

    const cmsPageData = useSelector((state: any) => state.CmsPageState);
    const slug = pathname.split('/app/').pop();

    useEffect(() => {
        if (slug) {
            dispatch(CmsPageAction({ slug, user_type: StorageConstants?.USERTYPEAPP }));
        }
    }, [slug, dispatch]);

    return (
        <>
            {cmsPageData?.loading ? <Spinner />:""}

            <main>
                <div className='container py-5'>
                    <h1 className='title mb-4'>{cmsPageData?.data?.data?.title ? cmsPageData?.data?.data?.title : ""}</h1>
                    <div dangerouslySetInnerHTML={{ __html: cmsPageData?.data?.data?.content }}>

                    </div>
                </div>
            </main>

        </>
    )
}

export default PrivacyAndPolicy;